// tslint:disable:trailing-comma
export interface DocumentsResponseItem {
  blobCustomerDocumentId: number;
  blobDocument: {
    container: {
      containerDesc: string
      containerId: number
    }
    documentId: number
    fileType: string
    guid: string
  };
  blobDocumentURL: string;
  customer: {
    customerId: number
    customerCode: string
    customerDesc: string
  };
  documentName: string;
  documentType: {
    documentTypeCode: string
    documentTypeDesc: string
    documenttypeId: number
  };
  productLineDesc: string;
  serviceCenterDesc: string;
  status: {
    docStatusCode: number
    docStatusId: number
  };
  storageType: string;
  uploadTimestamp: string;
  user: {
    userEmail: string
    userName: string
    useraccount: string
  };
}
